import React, { lazy } from 'react';
import { CalendarDays, ArrowRight, Facebook, Instagram, ExternalLink } from 'lucide-react';
// Badge oficial de fuente — texto siempre visible y legible
const OrgLogoBadgeText: React.FC<{
  name: string;
}> = ({
  name
}) => {
  if (!name) return null;
  return <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-lg shadow-lg border border-white/80" data-id="element-228">
      <span className="text-[10px] font-black uppercase tracking-widest text-charcoal notranslate" data-id="element-229">
        {name}
      </span>
    </div>;
};
export function NewsSection() {
  const news = [{
    titleEs: 'Listo, Preparado, ¡Vámonos! Departamento de Bomberos de Los Ángeles',
    titleEn: 'Ready - Set - Go! Los Angeles Fire Department',
    date: '05/15/2026',
    excerptEs: 'Los incendios forestales catastróficos están ocurriendo a un ritmo creciente. Muchas comunidades en las colinas de Los Ángeles están bajo amenaza continua. El programa "Listo, Preparado, ¡Vámonos!" está diseñado para guiarte paso a paso y asegurar que estés preparado.',
    excerptEn: 'Catastrophic brush fires are occurring at an increasing rate. The many hillside communities within Los Angeles are under continuous threat. The "Ready, Set, Go!" program is designed to walk you through the steps to take to ensure you are prepared.',
    image: 'https://cdn.magicpatterns.com/uploads/mW8n6ebG3dEwWRks9q2LGt/bomberos_loas_angeles.png',
    logoBg: 'bg-red-50',
    organization: 'LAFD',
    domain: 'lafd.org'
  }, {
    titleEs: 'Regístrate para Recibir Alertas de Emergencia de LA - NotifyLA',
    titleEn: 'Sign up for LA Emergency Alerts - NotifyLA',
    date: '05/12/2026',
    excerptEs: 'La Ciudad de Los Ángeles usa NotifyLA para enviar alertas de emergencia por teléfono, correo electrónico o mensaje de texto. Suscríbete para mantenerte informado sobre emergencias en tu vecindario, escuelas o negocios.',
    excerptEn: 'The City of Los Angeles uses NotifyLA to send emergency alerts via phone, email, or text. Subscribe to stay informed about emergencies in your neighborhood, at schools or businesses.',
    image: 'https://images.unsplash.com/photo-1516383274235-5f42d6c6426d?w=1200&q=85&auto=format&fit=crop',
    logoBg: 'bg-blue-50',
    organization: 'City of LA · NotifyLA',
    domain: 'emergency.lacity.gov'
  }, {
    titleEs: 'Guía de Emergencias y Desastres - LAFD',
    titleEn: 'Emergency Disaster Guide - LAFD',
    date: '05/10/2026',
    excerptEs: 'Los Ángeles está expuesto al riesgo de múltiples desastres. La preparación no solo consiste en tener un kit de supervivencia en tu hogar, lugar de trabajo o automóvil, sino también en tener el conocimiento que te acompañe a donde vayas.',
    excerptEn: 'Los Angeles is at risk for multiple disasters. Disaster preparedness not only consists of having a survival kit in your home, place of business, and your car, but it is also the knowledge that can travel with you.',
    image: 'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?w=1200&q=85&auto=format&fit=crop',
    logoBg: 'bg-orange-50',
    organization: 'LAFD',
    domain: 'lafd.org'
  }, {
    titleEs: 'Comité Ecuestre - Miércoles 20 de Mayo, 7pm',
    titleEn: 'Equestrian Committee - Wednesday, May 20th, 7pm',
    date: '05/08/2026',
    excerptEs: 'AGENDA de la REUNIÓN *Especial* del Comité Ecuestre del Concilio Vecinal de Sylmar. Miércoles 20 de Mayo, 2026 - 7:00 pm a 8:30 pm.',
    excerptEn: "Sylmar Neighborhood Council's Equestrian Committee *Special* MEETING AGENDA. Wednesday, May 20th, 2026 - 7:00 pm - 8:30 pm.",
    image: 'https://cdn.magicpatterns.com/uploads/b19k3B7qcY9GvykkPkXLub/ChatGPT_Image_2_jul_2026,_00_15_36.png',
    logoBg: 'bg-sylmar-light',
    organization: 'Sylmar Neighborhood Council',
    domain: 'sylmarneighborhoodcouncil.org',
    isLogo: true
  }, {
    titleEs: 'Emergencia por Fuga de Gas - SOLUCIONADA',
    titleEn: 'Gas Leak Emergency - CLEARED',
    date: '05/05/2026',
    excerptEs: 'Una tubería principal de gas rota causó una fuga de gas natural en Sylmar el sábado, lo que llevó a las autoridades a evacuar un complejo de apartamentos de 12 unidades por aproximadamente dos horas.',
    excerptEn: 'A ruptured gas main caused a leak of natural gas in Sylmar Saturday, prompting authorities to evacuate a 12-unit apartment complex for about two hours.',
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=1200&q=85&auto=format&fit=crop',
    logoBg: 'bg-yellow-50',
    organization: 'SoCalGas · LAFD',
    domain: 'socalgas.com'
  }];
  const sidebarBanners = [{
    titleEs: '¡FUEGO! ¡ESTÉ PREPARADO! PELIGROS DE ÁRBOLES',
    titleEn: 'FIRE! BE READY! TREE DANGERS',
    color: 'bg-red-600',
    url: 'https://www.lafd.org/ready-set-go'
  }, {
    titleEs: 'INFORMACIÓN DE LA OFICINA DE CORREOS',
    titleEn: 'US POST OFFICE INFORMATION',
    color: 'bg-blue-600',
    url: 'https://www.usps.com/'
  }, {
    titleEs: 'SÁBADO DE PEQUEÑOS NEGOCIOS',
    titleEn: 'SMALL BUSINESS SATURDAY',
    color: 'bg-amber-600',
    url: 'https://www.americanexpress.com/us/small-business/shop-small/'
  }, {
    titleEs: 'REGÍSTRESE PARA RECIBIR AGENDAS',
    titleEn: 'SIGN UP TO RECEIVE AGENDAS',
    color: 'bg-orange-500',
    url: 'https://www.sylmarneighborhoodcouncil.org/'
  }];
  return <section id="news" className="py-24 px-6 lg:px-8 bg-softblue" data-id="element-230">
      <div className="max-w-7xl mx-auto" data-id="element-231">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-4" data-id="element-232">
          <div data-id="element-233">
            <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-2 notranslate" data-id="element-234">
              Noticias y Anuncios
            </h2>
            <p className="text-xl text-sylmar font-medium notranslate" data-id="element-235">
              News & Announcements
            </p>
          </div>
          <a href="https://www.sylmarneighborhoodcouncil.org/page/viewNews/10197" target="_blank" rel="noopener noreferrer" className="text-sky hover:text-sky-dark font-bold flex flex-col items-end transition-colors group" data-id="element-236">
            <span className="flex items-center gap-2" data-id="element-237">
              Ver todas las noticias{' '}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-238" />
            </span>
            <span className="text-xs text-sky-dark font-normal italic" data-id="element-239">
              View all news
            </span>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12" data-id="element-240">
          {/* Main Content - News List (Left Column) */}
          <div className="lg:col-span-8 space-y-6" data-id="element-241">
            {news.map((item, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow border border-gray-100 flex flex-col sm:flex-row group cursor-pointer" data-id="element-242">
                <div className={`sm:w-64 h-48 sm:h-auto flex-shrink-0 overflow-hidden relative ${item.isLogo ? `${item.logoBg} flex items-center justify-center p-6` : ''}`} data-id="element-243">
                  <img src={item.image} alt={item.titleEs} className={`${item.isLogo ? 'max-w-full max-h-32 sm:max-h-40 object-contain notranslate' : 'w-full h-full object-cover'} group-hover:scale-105 transition-transform duration-500`} loading="lazy" data-id="element-244" />
                  {!item.isLogo && <>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent pointer-events-none" data-id="element-245"></div>
                      {/* Badge Oficial de Fuente */}
                      <OrgLogoBadgeText name={item.organization} data-id="element-246" />
                    </>}
                  <span className={`absolute bottom-2 left-2 right-2 text-[10px] font-bold text-center uppercase tracking-wider notranslate truncate px-2 py-1 rounded ${item.isLogo ? 'text-charcoal/60' : 'text-white bg-black/50 backdrop-blur-sm'}`} data-id="element-247">
                    {item.organization}
                  </span>
                </div>
                <div className="p-6 flex flex-col justify-center flex-grow" data-id="element-248">
                  <div className="flex items-center gap-2 text-xs font-bold text-sylmar mb-3" data-id="element-249">
                    <CalendarDays className="w-4 h-4" data-id="element-250" />
                    Publicado: {item.date}{' '}
                    <span className="text-gray-400 italic font-normal" data-id="element-251">
                      / Posted
                    </span>
                  </div>

                  {/* Título Bilingüe (Español Estelar) */}
                  <h3 className="text-xl font-bold text-charcoal mb-1 group-hover:text-sky transition-colors leading-tight" data-id="element-252">
                    {item.titleEs}
                  </h3>
                  <p className="text-sm text-gray-400 italic mb-3 leading-tight" data-id="element-253">
                    {item.titleEn}
                  </p>

                  {/* Extracto Bilingüe (Español Estelar) */}
                  <p className="text-gray-700 text-sm mb-2 line-clamp-3" data-id="element-254">
                    {item.excerptEs}
                  </p>
                  <p className="text-gray-400 text-xs italic mb-4 line-clamp-2" data-id="element-255">
                    {item.excerptEn}
                  </p>

                  <a href="https://www.sylmarneighborhoodcouncil.org/page/viewNews/10197" target="_blank" rel="noopener noreferrer" className="text-sylmar font-bold text-sm flex flex-col w-fit group-hover:text-sylmar-dark transition-colors" data-id="element-256">
                    <span className="flex items-center gap-1" data-id="element-257">
                      Leer más{' '}
                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-258" />
                    </span>
                    <span className="text-xs font-normal opacity-70 italic" data-id="element-259">
                      Read More
                    </span>
                  </a>
                </div>
              </div>)}

            <div className="text-center pt-4" data-id="element-260">
              <button className="bg-white border-2 border-charcoal text-charcoal hover:bg-charcoal hover:text-white px-8 py-3 rounded-xl font-bold transition-colors flex flex-col items-center mx-auto" data-id="element-261">
                <span data-id="element-262">Ver Publicaciones Anteriores</span>
                <span className="text-xs font-normal opacity-70 italic" data-id="element-263">
                  View Previous Posts
                </span>
              </button>
            </div>
          </div>

          {/* Sidebar (Right Column) */}
          <div className="lg:col-span-4 space-y-6" data-id="element-264">
            {/* Promotional Banners */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4" data-id="element-265">
              {sidebarBanners.map((banner, index) => <a key={index} href={banner.url} target="_blank" rel="noopener noreferrer" className={`${banner.color} text-white p-5 rounded-2xl shadow-md hover:shadow-lg transition-shadow cursor-pointer flex items-center justify-between group`} data-id="element-266">
                  <div className="flex flex-col pr-4" data-id="element-267">
                    <span className="font-bold text-sm leading-tight mb-1" data-id="element-268">
                      {banner.titleEs}
                    </span>
                    <span className="text-xs opacity-70 font-medium italic" data-id="element-269">
                      {banner.titleEn}
                    </span>
                  </div>
                  <ExternalLink className="w-5 h-5 opacity-70 group-hover:opacity-100 transition-opacity flex-shrink-0" data-id="element-270" />
                </a>)}
            </div>

            {/* Official Widgets */}
            <div className="space-y-4" data-id="element-271">
              <a href="https://myla311.lacity.org/" target="_blank" rel="noopener noreferrer" className="block bg-blue-600 text-white p-6 rounded-2xl shadow-md hover:bg-blue-700 transition-colors text-center" data-id="element-272">
                <h3 className="text-3xl font-black mb-2" data-id="element-273">MyLA 311</h3>
                <p className="text-sm font-bold mb-1" data-id="element-274">
                  Haz clic aquí o marca 311 desde cualquier teléfono
                </p>
                <p className="text-xs font-medium opacity-70 italic" data-id="element-275">
                  Click here or Dial 311 from any phone
                </p>
              </a>

              <a href="https://empowerla.org/" target="_blank" rel="noopener noreferrer" className="block bg-white border-2 border-sylmar p-6 rounded-2xl shadow-sm hover:bg-sylmar-light transition-colors text-center group" data-id="element-276">
                <h3 className="text-xl font-black text-sylmar mb-2 notranslate" data-id="element-277">
                  EMPOWER LA
                </h3>
                <p className="text-sm font-bold text-charcoal mb-1" data-id="element-278">
                  Departamento de Empoderamiento Vecinal
                </p>
                <p className="text-xs text-gray-500 font-medium italic" data-id="element-279">
                  Department of Neighborhood Empowerment
                </p>
              </a>
            </div>

            {/* Connect With Us */}
            <div className="bg-charcoal rounded-2xl p-6 shadow-sm text-white" data-id="element-280">
              <h4 className="font-bold text-white text-lg text-center mb-1" data-id="element-281">
                Síguenos en Línea
              </h4>
              <p className="text-sky text-xs text-center font-medium mb-4 italic" data-id="element-282">
                Follow Us Online
              </p>
              <div className="flex gap-4 justify-center" data-id="element-283">
                <a href="https://www.facebook.com/sylmarnc/" target="_blank" rel="noopener noreferrer" className="bg-[#1877F2] hover:opacity-90 p-3 rounded-xl transition-all shadow-md hover:-translate-y-1" data-id="element-284">
                  <Facebook className="w-6 h-6 fill-current" data-id="element-285" />
                </a>
                <a href="https://www.instagram.com/sylmar_nc?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] hover:opacity-90 p-3 rounded-xl transition-all shadow-md hover:-translate-y-1" data-id="element-286">
                  <Instagram className="w-6 h-6" data-id="element-287" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}